<template>
  <div class="form_countdown_continer">
    <div style="display: flex;align-items: center;" class="countdown_txt">
      <span class="left_tip">距离今日结束还剩</span>
      <div style="font-family: 'GBK'">
        <van-count-down :time="countData">
          <!--  时分秒-->
          <template #default="countData">
            <template v-for="(num,index) in padZero( countData.hours)">
              <span class="block">{{ num }}</span>
            </template>
            <span class="colon">:</span>
            <template v-for="(num,index) in padZero( countData.minutes)">
              <span class="block">{{ num }}</span>
            </template>
            <span class="colon">:</span>
            <template v-for="(num,index) in padZero( countData.seconds)">
              <span class="block">{{ num }}</span>
            </template>

          </template>
        </van-count-down>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "vantCountDown",
    data() {
      return {
        countData: new Date().setHours(24, 0, 0, 0) - Date.now(),
      }
    },
    methods: {
      //补零
      padZero(num) {
        return num < 10 ? (Array(2).join('0') + num).slice(-2).split('') : num.toString().split('')
      },
    }
  }
</script>

<style scoped>

</style>